import React from 'react';
import classnames from 'classnames';
import { NavButton } from './button/button';
import styles from './nav.scss';
export class Nav extends React.Component {
    constructor() {
        super(...arguments);
        this.handleNextClick = () => {
            const { isDisabled, onNextClick } = this.props;
            if (isDisabled) {
                return;
            }
            onNextClick();
        };
        this.handlePrevClick = () => {
            const { isDisabled, onPrevClick } = this.props;
            if (isDisabled) {
                return;
            }
            onPrevClick();
        };
    }
    renderPrevButton() {
        const { nextButtonClassName, prevButtonClassName, prevButtonAriaLabel, customArrowIcon, isRTL, } = this.props;
        const classNames = classnames({
            [nextButtonClassName]: isRTL,
            [prevButtonClassName]: !isRTL,
            [styles.arrowRight]: isRTL,
            [styles.arrowLeft]: !isRTL,
        });
        return (React.createElement(NavButton, { onClick: this.handlePrevClick, className: classNames, ariaLabel: prevButtonAriaLabel, dataHook: "prev-button", arrowIcon: customArrowIcon }));
    }
    renderNextButton() {
        const { nextButtonClassName, prevButtonClassName, nextButtonAriaLabel, customArrowIcon, isRTL, } = this.props;
        const classNames = classnames({
            [nextButtonClassName]: !isRTL,
            [prevButtonClassName]: isRTL,
            [styles.arrowRight]: !isRTL,
            [styles.arrowLeft]: isRTL,
        });
        return (React.createElement(NavButton, { onClick: this.handleNextClick, className: classNames, ariaLabel: nextButtonAriaLabel, dataHook: "next-button", arrowIcon: customArrowIcon }));
    }
    render() {
        const { isPrevVisible, isNextVisible, className, dataHook } = this.props;
        return (React.createElement("nav", { className: className, "data-hook": dataHook },
            isPrevVisible && this.renderPrevButton(),
            isNextVisible && this.renderNextButton()));
    }
}
//# sourceMappingURL=nav.js.map